import Toast from 'devextreme-react/toast';
import {positionConfig} from 'devextreme/animation/position';
import {system} from 'services/objects';
import {SnackbarObject} from 'services/snackbar/types';
import {SNACKBAR_TYPES} from 'services/interfaces/global-interfaces';
import SnackbarTemplate from './SnackbarTemplate';

const {MESSAGE_TIMEOUT} = system.DEFAULT_LOCALS;

type Props = {onClose: () => void} & SnackbarObject;

const Snackbar = ({type, message, onClose, title, docUrl}: Props) => {
  const defaultPosition: positionConfig = {
    at: 'left bottom',
    my: 'left bottom',
    offset: '10 -10',
  };

  const centerPosition: positionConfig = {
    of: '#root',
    at: 'center',
  };

  if (!type) return null;

  const position = type === SNACKBAR_TYPES.Help ? centerPosition : defaultPosition;

  return message || docUrl ? (
    <Toast
      onHiding={onClose}
      visible={!!(message || docUrl)}
      displayTime={MESSAGE_TIMEOUT}
      width={445}
      position={position}
    >
      <SnackbarTemplate message={message} type={type} title={title} docUrl={docUrl} onClickClose={onClose} />
    </Toast>
  ) : null;
};

export default Snackbar;
